import { defineComponent, reactive, ref, toRefs, watch } from "vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { warehouseCount, projectCount } from "./warehouse-tabs.service";
import { TabsType } from "./warehouse-tabs.interface";
import type { TabsProps } from "ant-design-vue";

export default defineComponent({
  isGlobal: true,
  name: "WarehouseTab",
  components: {},
  props: {
    value: {
      type: String,
    },
    isProject:{
      type: Boolean,
      default:true
    },
  },
  emits: ["update:value", "changeWare"],
  setup(props, { emit }) {
    const state = reactive({
      activeKey: "qb",
      mode: ref<TabsProps["tabPosition"]>("top"),
      tabsArr: <TabsType[]>[],
      showBtn: true,
    });

    let { data: warehouseList, run: runWarehouse } = warehouseCount();
    let { data: projectList, run: runproject } = projectCount();

    const getCount = async () => {
      let total = 0;
      if (state.showBtn) {
        await runproject();
        let list = projectList.value?.records || [];
        list.map((d) => {
          d.code = d.projectId;
          d.name = d.projectName;
          d.total = d.projectCount;
          total += Number(d.projectCount);
        });
        state.tabsArr = list;
      } else {
        await runWarehouse();
        let list = warehouseList.value?.records || [];
        list.map((d) => {
          d.code = d.repertotyId;
          d.name = d.repertotyName;
          d.total = d.warehouseCount;
          total += Number(d.warehouseCount);
        });
        state.tabsArr = list;
      }
      state.tabsArr.unshift({ code: "qb", name: "全部", total });
    };

    const changeTab = (p) => {
      emit("update:value", p);
    };
    watch(
      () => props.value,
      () => {
        state.activeKey = props.value||'qb';
      }
    );
    onMountedOrActivated(async () => {
      state.showBtn = props.isProject
      getCount();
    });

    const onChangeBtn = () => {
      state.showBtn = !state.showBtn;
      emit("changeWare");
      getCount();
    };

    return {
      ...toRefs(state),
      changeTab,
      onChangeBtn,
      getCount
    };
  },
});
